import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setCvSwanOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getCardioSwanOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCardioSwanOptions])
    const { entity } = response
    yield put(setCvSwanOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCardioSwanOptions() error: ${e}`))
  }
}

export function* getCardioSwanOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCardioSwanOptions)
}
